/**
 * Google Preferred Sources deeplink — single source of truth.
 *
 * Pre-fills pixelmojo.io into Google's source-preferences tool so a reader can
 * add us as a Preferred Source in one click. Preferred Sources is a personalized
 * signal: for users who opt in, it surfaces our content more prominently in Top
 * Stories, Google Discover, AI Overviews, and AI Mode. It amplifies reach among
 * an existing audience; it is not an organic ranking factor.
 *
 * Domain is pixelmojo.io (never .com).
 *
 * NOTE: verify this URL loads with the domain pre-filled before relying on any
 * CTA built on it — Google had a Feb 2026 bug where the ?q= param failed to
 * pre-fill (since resolved by the community).
 *
 * If this string changes, also update the hardcoded copy in the broadcast email
 * footer: scripts/send-product-announcement.ts (buildVectorHiveFooter).
 */
export const PREFERRED_SOURCE_URL =
  'https://www.google.com/preferences/source?q=pixelmojo.io'
